module.exports = __webpack_public_path__ + "6c714acdf26b7bce06583d59762c25c8.png";